export default () => ({
    show: false,
    is_open: false,

    mounted() {
        gsap.set(this.$refs.slice01, { yPercent: 101 });
        gsap.set(this.$refs.slice02, { yPercent: -101 });
        gsap.set(this.$refs.slice03, { yPercent: 101 });

        this.$watch('$store.lightboxCards.open', value => {
            this.is_open = value;

            if (value) {
                this.open();
            } else {
                this.close();
            }
        });
    },

    animationFinisher() {
        this.$store.lightboxCards.animating = false;
    },

    open() {
        document.body.classList.add('no-scroll');
        this.show = true;

        const openLightbox = gsap.timeline({
            defaults: { ease: 'expo.inOut' },
            onComplete: () => {
                this.animationFinisher();
            }
        });

        openLightbox
            .fromTo(this.$refs.slice01, { yPercent: 101 }, { duration: 0.8, yPercent: 0 })
            .fromTo(this.$refs.slice02, { yPercent: -101 }, { duration: 0.8, yPercent: 0 }, '>-0.6')
            .fromTo(this.$refs.slice03, { yPercent: 101 }, { duration: 0.8, yPercent: 0 }, '>-0.6')
            .addLabel('phase_two')

            .fromTo('[data-lightbox-card]',
                {
                    yPercent: 40,
                    opacity: 0
                }, {
                    duration: 0.5,
                    yPercent: 0,
                    opacity: 1,
                    stagger: 0.05
                },
                '>-0.6'
            )

            .fromTo(this.$refs.headline, { opacity: 0 }, { duration: 0.3, opacity: 1, ease: 'quad.inOut' }, 'phase_two')
            .to(this.$refs.button, { duration: 0.3, autoAlpha: 1, ease: 'quad.inOut' }, 'phase_two+=0.4');

    },

    close() {
        const closeLightbox = gsap.timeline({
            defaults: { ease: 'circ.inOut' },
            onComplete: () => {
                document.body.classList.remove('no-scroll');
                this.show = false;
                this.animationFinisher();
            }
        });

        closeLightbox
            .to(this.$refs.button, { duration: 0.3, autoAlpha: 0 })
            .to(this.$refs.headline, { duration: 0.3, opacity: 0, ease: 'quad.inOut' }, '<0.1')
            .to(
                '[data-lightbox-card]',
                {
                    duration: 0.4,
                    yPercent: -40,
                    opacity: 0,
                    stagger: 0.04,
                    ease: 'quint.out'
                },
                '<0.1'
            )

            .to(this.$refs.slice01, { duration: 0.7, yPercent: -101, ease: 'expo.inOut' })
            .to(this.$refs.slice02, { duration: 0.7, yPercent: 101, ease: 'expo.inOut' }, '>-0.6')
            .to(this.$refs.slice03, { duration: 0.7, yPercent: -101, ease: 'expo.inOut' }, '>-0.6');
    },

    toggle() {
        if (this.is_open) {
            this.$store.lightboxCards.toggle()
        }
    }
});
